import React, { useMemo } from 'react'
import { TextProps } from '.'
import ButtonPrimary from 'components/Shared/Button/OldButton/ButtonPrimary'
import { theme } from 'theme'
import { noop } from 'lodash'

interface ButtonSetProps {
    confirmText?: string
    cancelText?: string
    onConfirm?: () => void
    onCancel?: () => void
    isSubmitType?: boolean
    disabled?: boolean
    fontSize?: string | number
}

const ButtonSet: React.FC<ButtonSetProps> = ({
    confirmText,
    cancelText,
    onConfirm = noop,
    onCancel = noop,
    isSubmitType,
    disabled,
    fontSize,
}) => {
    const textProps = useMemo(
        () =>
            ({
                fontWeight: 'bold',
                fontSize: fontSize ? fontSize : '14px',
            }) as TextProps,
        [],
    )
    return (
        <>
            {cancelText && (
                <ButtonPrimary
                    themeColor="governorBayOutline"
                    textProps={textProps}
                    onClick={onCancel}
                    mr={confirmText && theme.spacing.xs}
                >
                    {cancelText}
                </ButtonPrimary>
            )}
            {confirmText && (
                <ButtonPrimary
                    themeColor={disabled ? 'disabled' : 'astronaut'}
                    textProps={textProps}
                    onClick={onConfirm}
                    type={isSubmitType ? 'submit' : undefined}
                    disabled={disabled}
                >
                    {confirmText}
                </ButtonPrimary>
            )}
        </>
    )
}

export default ButtonSet
